<template>
  <button id="button-with-icon" class="button" @click="clicked">
    <span class="icon left-icon">
      <slot name="leftIcon" />
      <!-- <font-awesome-icon icon="file-download" /> -->
    </span>
    <span class="button-title">
      <slot name="buttonTitle" />
    </span>
    <span class="icon icon-right">
      <slot name="rightIcon" />
    </span>
  </button>
</template>

<script>
export default {
  props: {
    clicked: {
      type: Function,
      required: true,
    },
  },
};
</script>

<style lang="scss">
#button-with-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  cursor: pointer;

  .button-title {
    width: 80%;
  }

  .icon-right {
    margin-left: auto;
  }
}
</style>
